import React from 'react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { ReactComponent as InfoIcon } from 'new/components/icons/fi-rr-info.svg';
import { ReactComponent as DeleteIcon } from 'new/components/icons/fi-sr-cross-circle.svg';
import { ProfileImage } from 'new/elements/ProfileImage';
import { Custodian } from 'new/entities/Custodian';

interface DomainCustodianListItemProps {
  data: Custodian;
  onDeleteCustodian: (data: Custodian) => void;
  canDelete: boolean;
}

const DomainCustodianListItem = (props: DomainCustodianListItemProps) => {
  const { data, onDeleteCustodian, canDelete } = props;
  return (
    <>
      {data ? (
        <Stack direction="row" gap="8px" alignItems="center" paddingBottom="16px" width="320px">
          {data?.custodian_type === 'org' ? (
            <Tooltip title={`${data?.full_name} can access all Data Domains`} arrow={true}>
              <div className="custodian-info-icon">
                <InfoIcon />
              </div>
            </Tooltip>
          ) : canDelete ? (
            <IconButton onClick={() => onDeleteCustodian(data)}>
              <DeleteIcon />
            </IconButton>
          ) : (
            <IconButton disabled sx={{ visibility: 'hidden' }}>
              <DeleteIcon />
            </IconButton>
          )}
          <ProfileImage color={'rgba(0,0,0,0.5)'} size="small" fullName={data?.full_name} />
          <Stack direction="column">
            <Typography variant="body2">{data?.full_name}</Typography>
            <Typography variant="body3">{data?.email}</Typography>
          </Stack>
        </Stack>
      ) : null}
    </>
  );
};

export default DomainCustodianListItem;
